import { Snackbar, Alert, Card, CircularProgress, Backdrop, Icon, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";

export default function LoyaltyConsumersPage() {
  usePageTitle("Loyalty Consumers");
  const navigate = useNavigate();
  const { ref } = useParams();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [consumers, setConsumers] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchConsumers = async () => {
      setLoading(true);
      await axios
        .get(`/portal/tm/loyalty/promotions/${ref}/consumers.json`)
        .then((res) => {
          setLoading(false);
          if (res.data.status === "success") {
            const rows = (res.data.data.consumers || []).map((row) => ({
              name: `${row.first_name} ${row.last_name}`,
              email: row.email_address || "---",
              phone: row.phone_number || "---",
              agent: row.agent_id,
              created: row.created,
              actions: (
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  iconOnly
                  onClick={() => navigate(`/tm/loyalty/promotions/consumers/${row.reference}`)}
                >
                  <Icon fontSize="small">visibility</Icon>
                </MDButton>
              ),
            }));
            setConsumers(rows);
            setLoaded(true);
          } else {
            setErrMsg(res.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setLoading(false);
          setErrMsg("Failed to fetch consumers.");
          setOpen(true);
        });
    };
    fetchConsumers();
  }, []);

  const handleExport = async () => {
    setLoading(true);

    await axios
      .get(`/portal/tm/loyalty/promotions/${ref}/consumers.json?export=true`, {
        responseType: "blob",
      })
      .then((res) => {
        setLoading(false);

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", `loyalty_consumers_${ref}.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        setLoading(false);
        setErrMsg("Failed to export consumers.");
        setOpen(true);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setOpen(false)} severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        {loaded && (
          <Card>
            <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6">Loyalty Consumers</MDTypography>
              <MDBox display="flex" gap={1}>
                <MDButton
                  variant="outlined"
                  color="dark"
                  size="small"
                  onClick={() => navigate(`/tm/loyalty/promotions/${ref}`)}
                  startIcon={<Icon>west</Icon>}
                >
                  Back
                </MDButton>
                <MDButton
                  variant="contained"
                  color="dark"
                  onClick={handleExport}
                  startIcon={<Icon>download</Icon>}
                >
                  Export Excel
                </MDButton>
              </MDBox>
            </MDBox>
            <DataTable
              table={{
                columns: [
                  { Header: "Name", accessor: "name" },
                  { Header: "Email", accessor: "email" },
                  { Header: "Phone", accessor: "phone" },
                  { Header: "Agent ID", accessor: "agent" },
                  { Header: "Created", accessor: "created" },
                  { Header: "Actions", accessor: "actions", align: "right" },
                ],
                rows: consumers,
              }}
              canSearch={false}
              isSorted
              entriesPerPage={false}
              showTotalEntries
              noEndBorder
            />
          </Card>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
